import React, { useEffect, useState } from 'react';
import { Card, Grid, Input, Checkbox } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { AddressSuggestions, PartySuggestions, FioSuggestions } from 'react-dadata';
import 'react-dadata/dist/react-dadata.css';

import './styles.css';
import {getAddressFields, getCountries, isCountriesFetching} from './reducer';

import {
  ADDRESS_FIRSTNAME,
  ADDRESS_LASTNAME,
  ADDRESS_COMPANY,
  ADDRESS_PHONE_COUNTRY,
  ADDRESS_PHONE,
  ADDRESS_EMAIL,
  ADDRESS_COMPANY_INN,
  ADDRESS_COMPANY_KPP,
  ADDRESS_COMPANY_OGRN,
  ADDRESS_COMPANY_CHIEF_NAME,
  ADDRESS_COMPANY_CONTACT_NAME,
  ADDRESS_COMPANY_JOB_TITLE,
  ADDRESS_COMPANY_SCOPE,
  ADDRESS_COMPANY_LEGAL_ADDR,
  ADDRESS_COMPANY_POST_ADDR,
  ADDRESS_IS_JURIDIC,
  setAddressFields,
  fetchCounties,
} from './actions';
import { DADATA_API_KEY } from '../../config/secrets';
import _ from "lodash";
import PhoneCountryMask from "./PhoneCountryMask";
import { setFieldsFromUserData } from "./actions";

export default function AddressCard(props) {
  const {dispatch, userData} = props;
  const fields = useSelector((state) => getAddressFields(state.address));
  const isFetching = useSelector((state) => isCountriesFetching(state.address));
  const countries = useSelector((state) => getCountries(state.address));

  useEffect(() => {
    if (userData && (!fields[ADDRESS_FIRSTNAME] && !fields[ADDRESS_LASTNAME])) {
      const formattedFields = setFieldsFromUserData(userData);
      dispatch(setAddressFields(formattedFields));
      setIsJuridic(formattedFields[ADDRESS_IS_JURIDIC]);
    }

    if (!countries || !countries.countries) {
      dispatch(fetchCounties());
    }

    ValidateFields();
  }, [userData]);

  const [isJuridic, setIsJuridic] = useState(fields[ADDRESS_IS_JURIDIC] !== false);

  useEffect(() => {
    if (!countries || !countries.countries) {
      dispatch(fetchCounties());
    }
    ValidateFields();
  }, []);

  useEffect(() => {
    fields[ADDRESS_IS_JURIDIC] = isJuridic;
    ValidateFields();
  }, [isJuridic]);

  const [state, setState] = useState({
    errors: {},
  });

  let listPhoneCountries = [];
  if (!isFetching && countries && countries.countries) {
    listPhoneCountries = Object.values(countries.countries).map((element, index) => (
        {
          key:  index,
          text: element.country_ru,
          flag: _.lowerCase(element.iso),
          value: element.iso,
          className: "dropdown-item",
          phone_mask: element.phone_mask,
        }
    ));
  }

  function setCompanyField(e) {
    fields[ADDRESS_COMPANY] = e.target.value;
    fields[ADDRESS_COMPANY_INN] = '';
    fields[ADDRESS_COMPANY_KPP] = '';
    fields[ADDRESS_COMPANY_OGRN] = '';
    fields[ADDRESS_COMPANY_CHIEF_NAME] = '';
    fields[ADDRESS_COMPANY_LEGAL_ADDR] = '';
    ValidateFields();
  }

  function setDaDataCompanyField(e) {
    fields[ADDRESS_COMPANY] = e.value;
    fields[ADDRESS_COMPANY_INN] = e.data.inn || '';
    fields[ADDRESS_COMPANY_KPP] = e.data.kpp || '';
    fields[ADDRESS_COMPANY_OGRN] = e.data.ogrn || '';

    if (e.data.management && e.data.management.name) {
      fields[ADDRESS_COMPANY_CHIEF_NAME] = e.data.management.name;
    }

    if (e.data.address && e.data.address.unrestricted_value) {
      fields[ADDRESS_COMPANY_LEGAL_ADDR] = e.data.address.unrestricted_value;
    }

    ValidateFields();
  }

  function setField(e) {
    fields[e.target.name] = e.target.value;
    ValidateFields();
  }

  function setDirectField(name, data) {
    fields[name] = data;
    ValidateFields();
  }

  function ValidateFields() {
    let errors = {};

    if (!fields[ADDRESS_FIRSTNAME])
      errors[ADDRESS_FIRSTNAME] = 'обязательно для заполнения';
    else if (!fields[ADDRESS_FIRSTNAME].match(/^[a-zA-Zа-яА-ЯёЁ\-\s]+$/))
      errors[ADDRESS_FIRSTNAME] = 'допускаются буквы, пробел и дефис';

    if (!fields[ADDRESS_LASTNAME])
      errors[ADDRESS_LASTNAME] = 'обязательно для заполнения';
    else if (!fields[ADDRESS_LASTNAME].match(/^[a-zA-Zа-яА-ЯёЁ\-\s]+$/))
      errors[ADDRESS_LASTNAME] = 'допускаются буквы, пробел и дефис';

    if (!fields[ADDRESS_PHONE])
      errors[ADDRESS_PHONE] = 'обязательно для заполнения';
    else if (fields[ADDRESS_PHONE].indexOf('_') >= 0)
      errors[ADDRESS_PHONE] = 'введите номер полностью';

    if (fields[ADDRESS_EMAIL]) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(fields[ADDRESS_EMAIL])) {
        errors[ADDRESS_EMAIL] = 'неверный формат эл.почты';
      }
    }

    if (isJuridic) {
      if (!fields[ADDRESS_COMPANY])
        errors[ADDRESS_COMPANY] = 'обязательно для заполнения';

      if (!fields[ADDRESS_COMPANY_JOB_TITLE])
        errors[ADDRESS_COMPANY_JOB_TITLE] = 'обязательно для заполнения';

      if (fields[ADDRESS_COMPANY_INN] && !/^\d{10}$/.test(fields[ADDRESS_COMPANY_INN])) {
        errors[ADDRESS_COMPANY_INN] = 'ИНН должен содержать 10 цифр';
      }

      if (fields[ADDRESS_COMPANY_KPP] && !/^\d{9}$/.test(fields[ADDRESS_COMPANY_KPP])) {
        errors[ADDRESS_COMPANY_KPP] = 'КПП должен содержать 9 цифр';
      }

      if (fields[ADDRESS_COMPANY_OGRN] && !/^\d{13}$/.test(fields[ADDRESS_COMPANY_OGRN])) {
        errors[ADDRESS_COMPANY_OGRN] = 'ОГРН должен содержать 13 цифр';
      }
    }

    fields['hasErrors'] = Object.keys(errors).length > 0;
    setState({ errors });
    dispatch(setAddressFields(fields));
  }

  return (
      <Card centered className="shipping-details-card">
        <Card.Header className="user-card-header" as="h3" color="red" textAlign="center">
          Персональные данные
        </Card.Header>
        <Card.Content>
          <div className="entity-type-switcher">
            <Checkbox
                radio
                label="Юридическое лицо"
                name="entityType"
                value="juridic"
                checked={isJuridic}
                onChange={() => setIsJuridic(true)}
            />
            <Checkbox
                radio
                label="Физическое лицо"
                name="entityType"
                value="individual"
                checked={!isJuridic}
                onChange={() => setIsJuridic(false)}
            />
          </div>

          <Grid columns="equal" className="shipping-details-grid">
            {/* Общие поля для всех типов лиц */}
            <Grid.Row className="shipping-details-row">
              <Grid.Column className="shipping-field-cell">
                <FioSuggestions
                    containerClassName="shipping-field shipping-first-name"
                    inputProps={{
                      placeholder: 'Имя *',
                      name: [ADDRESS_FIRSTNAME],
                      onChange: (event) => setField(event),
                    }}
                    hintText="Выберите вариант или продолжите ввод ..."
                    filterParts={['NAME']}
                    count={4}
                    token={DADATA_API_KEY}
                    defaultQuery={fields[ADDRESS_FIRSTNAME]}
                    onChange={(e) => setDirectField(ADDRESS_FIRSTNAME, e.value)}
                />
                <span className="shipping-field-error">{state.errors[ADDRESS_FIRSTNAME]}</span>
              </Grid.Column>
              <Grid.Column className="shipping-field-cell">
                <FioSuggestions
                    containerClassName="shipping-field shipping-last-name"
                    inputProps={{
                      placeholder: 'Фамилия *',
                      name: [ADDRESS_LASTNAME],
                      onChange: (event) => setField(event),
                    }}
                    hintText="Выберите вариант или продолжите ввод ..."
                    filterParts={['SURNAME']}
                    count={4}
                    token={DADATA_API_KEY}
                    defaultQuery={fields[ADDRESS_LASTNAME]}
                    onChange={(e) => setDirectField(ADDRESS_LASTNAME, e.value)}
                />
                <span className="shipping-field-error">{state.errors[ADDRESS_LASTNAME]}</span>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row className="shipping-details-row">
              <Grid.Column className="shipping-field-cell">
                <PhoneCountryMask
                    extraClass="shipping-field shipping-phone"
                    countries={listPhoneCountries}
                    loading={isFetching}
                    country={fields[ADDRESS_PHONE_COUNTRY]}
                    phone={fields[ADDRESS_PHONE]}
                    handleChangeField={setDirectField}
                    nameCountry={ADDRESS_PHONE_COUNTRY}
                    namePhone={ADDRESS_PHONE}
                    fluid={true}
                />
                <span className="shipping-field-error">{state.errors[ADDRESS_PHONE]}</span>
              </Grid.Column>
              <Grid.Column className="shipping-field-cell">
                <Input
                    className="shipping-field shipping-email"
                    fluid
                    placeholder="Электронная почта"
                    name={ADDRESS_EMAIL}
                    value={fields[ADDRESS_EMAIL]}
                    onChange={setField}
                />
                <span className="shipping-field-error">{state.errors[ADDRESS_EMAIL]}</span>
              </Grid.Column>
            </Grid.Row>

            {/* Дополнительные поля для юридических лиц */}
            {isJuridic && (
                <>
                  <Grid.Row className="shipping-details-row">
                    <Grid.Column className="shipping-field-cell">
                      <PartySuggestions
                          containerClassName="shipping-field shipping-company-name"
                          inputProps={{
                            placeholder: 'Название компании или ИП *',
                            name: [ADDRESS_COMPANY],
                            onChange: (event) => setCompanyField(event),
                          }}
                          hintText="Выберите вариант или продолжите ввод ..."
                          filterStatus={['ACTIVE']}
                          count={4}
                          token={DADATA_API_KEY}
                          defaultQuery={fields[ADDRESS_COMPANY]}
                          onChange={setDaDataCompanyField}
                      />
                      <span className="shipping-field-error">{state.errors[ADDRESS_COMPANY]}</span>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row className="shipping-details-row">
                    <Grid.Column className="shipping-field-cell">
                      <Input
                          className="shipping-field"
                          fluid
                          placeholder="ИНН"
                          name={ADDRESS_COMPANY_INN}
                          value={fields[ADDRESS_COMPANY_INN]}
                          onChange={setField}
                          disabled={!!fields[ADDRESS_COMPANY_INN]}
                      />
                      <span className="shipping-field-error">{state.errors[ADDRESS_COMPANY_INN]}</span>
                    </Grid.Column>
                    <Grid.Column className="shipping-field-cell">
                      <Input
                          className="shipping-field"
                          fluid
                          placeholder="КПП"
                          name={ADDRESS_COMPANY_KPP}
                          value={fields[ADDRESS_COMPANY_KPP]}
                          onChange={setField}
                          disabled={!!fields[ADDRESS_COMPANY_KPP]}
                      />
                      <span className="shipping-field-error">{state.errors[ADDRESS_COMPANY_KPP]}</span>
                    </Grid.Column>
                    <Grid.Column className="shipping-field-cell">
                      <Input
                          className="shipping-field"
                          fluid
                          placeholder="ОГРН"
                          name={ADDRESS_COMPANY_OGRN}
                          value={fields[ADDRESS_COMPANY_OGRN]}
                          onChange={setField}
                          disabled={!!fields[ADDRESS_COMPANY_OGRN]}
                      />
                      <span className="shipping-field-error">{state.errors[ADDRESS_COMPANY_OGRN]}</span>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row className="shipping-details-row">
                    <Grid.Column className="shipping-field-cell">
                      <Input
                          className="shipping-field"
                          fluid
                          placeholder="Руководитель"
                          name={ADDRESS_COMPANY_CHIEF_NAME}
                          value={fields[ADDRESS_COMPANY_CHIEF_NAME]}
                          onChange={setField}
                          disabled={!!fields[ADDRESS_COMPANY_CHIEF_NAME]}
                      />
                    </Grid.Column>
                    <Grid.Column className="shipping-field-cell">
                      <FioSuggestions
                          containerClassName="shipping-field"
                          inputProps={{
                            placeholder: 'ФИО',
                            name: [ADDRESS_COMPANY_CONTACT_NAME],
                            onChange: (event) => setField(event),
                          }}
                          hintText="Выберите вариант или продолжите ввод ..."
                          filterParts={['NAME', 'SURNAME', 'PATRONYMIC']}
                          count={4}
                          token={DADATA_API_KEY}
                          defaultQuery={fields[ADDRESS_COMPANY_CONTACT_NAME]}
                          onChange={(e) => setDirectField(ADDRESS_COMPANY_CONTACT_NAME, e.value)}
                      />
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row className="shipping-details-row">
                    <Grid.Column className="shipping-field-cell">
                      <AddressSuggestions
                          containerClassName="shipping-field"
                          inputProps={{
                            placeholder: 'Юридический адрес',
                            name: [ADDRESS_COMPANY_LEGAL_ADDR],
                            onChange: (event) => setField(event),
                          }}
                          defaultQuery={fields[ADDRESS_COMPANY_LEGAL_ADDR]}
                          hintText="Выберите вариант или продолжите ввод ..."
                          count={4}
                          token={DADATA_API_KEY}
                          onChange={(e) => setDirectField(ADDRESS_COMPANY_LEGAL_ADDR, e.unrestricted_value)}
                          filterFromBound="city"
                          filterToBound="house"
                          disabled={!!fields[ADDRESS_COMPANY_LEGAL_ADDR]}
                      />
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row className="shipping-details-row">
                    <Grid.Column className="shipping-field-cell">
                      <AddressSuggestions
                          containerClassName="shipping-field"
                          inputProps={{
                            placeholder: 'Почтовый адрес',
                            name: [ADDRESS_COMPANY_POST_ADDR],
                            onChange: (event) => setField(event),
                          }}
                          defaultQuery={fields[ADDRESS_COMPANY_POST_ADDR]}
                          hintText="Выберите вариант или продолжите ввод ..."
                          count={4}
                          token={DADATA_API_KEY}
                          onChange={(e) => setDirectField(ADDRESS_COMPANY_POST_ADDR, e.unrestricted_value)}
                          filterFromBound="city"
                          filterToBound="house"
                      />
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row className="shipping-details-row">
                    <Grid.Column className="shipping-field-cell">
                      <Input
                          className="shipping-field"
                          fluid
                          placeholder="Сфера деятельности"
                          name={ADDRESS_COMPANY_SCOPE}
                          value={fields[ADDRESS_COMPANY_SCOPE]}
                          onChange={setField}
                      />
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row className="shipping-details-row">
                    <Grid.Column className="shipping-field-cell">
                      <Input
                          className="shipping-field"
                          fluid
                          placeholder="Кем являетесь / должность *"
                          name={ADDRESS_COMPANY_JOB_TITLE}
                          value={fields[ADDRESS_COMPANY_JOB_TITLE]}
                          onChange={setField}
                      />
                      <span className="shipping-field-error">{state.errors[ADDRESS_COMPANY_JOB_TITLE]}</span>
                    </Grid.Column>
                  </Grid.Row>
                </>
            )}
          </Grid>
        </Card.Content>
      </Card>
  );
}